<div class='experience-engagements-page'>

	<toolbar icon='Experience'>

		<button class="btn btn-light" (click)='experienceService.reloadData()' KendoTooltip [attr.title]="'Reload'"><i class='far fa-sync-alt' style="display: inline-block;width: 1.5em;"></i></button>

		<droplist [items]='[]' [popupConfig]='popupConfig' [navigation]='true'>
		</droplist>

		<div style='display:inline-block;width:300px'>
			<trimester-droplist [trimesterWindow]="trimesterWindow"></trimester-droplist>
		</div>

	</toolbar>

	<page-tabs [tabNames]='["Engagements", "Tab1", "Tab2"]' [pageService]='pageService' (layoutChange)='onLayoutChange($event)'>
		<ng-template pageTab1>
			<experience-engagements-views-part></experience-engagements-views-part>
		</ng-template>

		<ng-template pageTab2>
			<experience-engagements-tab-1-part></experience-engagements-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<experience-engagements-tab-2-part></experience-engagements-tab-2-part>
		</ng-template>
	</page-tabs>

</div>